import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function ProgressBar(_a) {
    var percentCompleted = _a.percentCompleted;
    return (_jsx("div", { className: "progress-bar-block", children: percentCompleted > 0 && (_jsxs("div", { className: "progress-bar", children: [_jsx("progress", { value: percentCompleted, max: "100" }), _jsx("div", { className: "progress-bar-completion", children: _jsxs("p", { children: ["Completed: ", percentCompleted, "%"] }) })] })) }));
}
;
